import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';

import WithSkeleton from '../../../common/WithSkeleton';
import { Constants } from '../../../../helpers/Constants';
import styles from './styles';

interface IProfileContentConfig {
  key: number | string;
  label: string;
  value: string | number | React.ReactNode;
  customOpen?: () => void;
  isUrl?: boolean;
}

interface IExperienceContent {
  content?: Array<IProfileContentConfig>;
  customComponent?: React.ReactNode;
  successAction: string;
}

const ExperienceContent: FC<IExperienceContent> = ({
  content,
  successAction,
  customComponent,
}) => {
  const SkeletonTypography = WithSkeleton({
    successAction,
    variant: Constants.variant.text,
  })(Typography);

  return (
    <Box component="div">
      {customComponent
        ?? content?.map((item) => {
          const { key, label, value, customOpen, isUrl } = item ?? {};

          return (
            <Box key={key} sx={styles.container}>
              <Box
                sx={[styles.labelContainer, isUrl ? styles.anchorLabel : {}]}
              >
                <Typography sx={styles.labelFont}>{label}</Typography>
              </Box>
              <Box sx={styles.valueContainer}>
                {isUrl ? (
                  <Typography
                    component="a"
                    target="_blank"
                    onClick={customOpen}
                    sx={styles.anchorFont}
                  >
                    {value}
                  </Typography>
                ) : (
                  <SkeletonTypography sx={styles.valueFont}>
                    {value}
                  </SkeletonTypography>
                )}
              </Box>
            </Box>
          );
        })}
    </Box>
  );
};

export default ExperienceContent;
